import React from 'react'

import { withMessages } from '../../components/Msg'

const scriptUrl = '//cdn.iflychat.com/js/iflychat-v2.min.js'

function loadScript(src) {
  const tag = document.createElement('script')
  tag.async = true
  tag.src = src
  return new Promise((resolve, reject) => {
    tag.onload = resolve
    tag.onerror = reject
    document.querySelector('body').appendChild(tag)
  })
}

function log(...args) {
  console.log('CHAT:', ...args)
}

/**
 * Chat page which initializes iflychat dom elements and loads script.
 * It is assumed to be included in an iframe
 */
class ChatRoom extends React.Component {
  // once the chat script is loaded, it can work offline just fine
  loading = false
  loaded = false

  render() {
    const { roomId, mode, messages } = this.props
    const className =
      mode === 'full' ? 'iflychat-embed-full-chat' : 'iflychat-embed'
    return (
      <div
        data-room-id={roomId}
        data-height="100%"
        data-width="100%"
        className={className}
      >
        <h3 ref={this.onMessageRef}>{messages['addons.Chat.loading']}</h3>
      </div>
    )
  }

  shouldComponentUpdate() {
    // this is intended - props cannot be changed
    // to load different chat you need to load it in another iframe
    return false
  }

  onMessageRef = r => {
    this.messageRef = r
  }

  setMessage(message) {
    if (this.messageRef) {
      this.messageRef.textContent = message
    }
  }

  onOnline = () => {
    log('CHAT: back online')
    if (this.loading) {
      return
    }
    this.tryLoadChat()
  }

  tryLoadChat() {
    if (this.loaded) {
      this.loading = false
      return
    }
    const { messages, appId } = this.props
    log('CHAT: loading chat...')
    if (!window.navigator.onLine) {
      log('CHAT: offline')
      this.loading = false
      this.setMessage(messages['addons.Chat.offline'])
      return
    }
    const src = scriptUrl + '?app_id=' + appId
    this.setMessage(messages['addons.Chat.loading'])
    this.loading = true
    loadScript(src)
      .then(() => {
        this.loaded = true
        this.loading = false
        log('CHAT: loaded')
      })
      .catch(err => {
        this.loaded = true
        this.loading = false
        this.setMessage(messages['addons.Chat.error'])
        console.error(err)
      })
  }

  componentDidMount() {
    window.addEventListener('online', this.onOnline)
    window.iflychat_auth_token = this.props.token
    this.tryLoadChat()
  }
}

export default withMessages(ChatRoom)



// WEBPACK FOOTER //
// ./src/addons/chat/ChatRoom.js